/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { getGohonzonType } from "../../utils";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style } from "./styles";

function GohonzonReturnRequest({ member, onMemberSelect }) {
  if (isEmptyObj(member)) {
    return null;
  }
  const { gohonzonMemberships } = member;
  const requestbtnDisabled = !gohonzonMemberships?.length;

  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.fullName || "-"}
        <br />
        {member.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.mobileNumber || "-"}
        <br />
        {member.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.divisionName || "-"}</TableCell>
      <TableCell style={style.Cell}>{member.regionName || "-"}</TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(gohonzonMemberships?.[0]?.type) || "-"}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <Button
            variant="outlined"
            disabled={requestbtnDisabled}
            label="REQUEST RETURN"
            style={
              requestbtnDisabled
                ? {
                    ...style.actionBtn,
                    opacity: ".5",
                    pointerEvents: "none",
                  }
                : style.actionBtn
            }
            onClick={() => onMemberSelect(member.memberId, `return`)}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonReturnRequest;
